import { render, staticRenderFns } from "./kw_tabs.vue?vue&type=template&id=17dda128&scoped=true&"
import script from "./kw_tabs.vue?vue&type=script&lang=js&"
export * from "./kw_tabs.vue?vue&type=script&lang=js&"
import style0 from "./kw_tabs.vue?vue&type=style&index=0&id=17dda128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dda128",
  null
  
)

component.options.__file = "kw_tabs.vue"
export default component.exports